(() => {
  'use strict';
  if (document.documentElement.hasAttribute('data-ambient-forms-guard')) return;
  document.documentElement.setAttribute('data-ambient-forms-guard', '1');

  const selector = '#app-embed-container-517779, #app-embed-container-525078';
  const closeSelector = '[role="button"][class*="_formCloseButton_"]';
  const sessionKey = 'ambient-newsletter-shown-v1';
  const records = new Map();
  const phone = window.matchMedia('(max-width: 767px)');
  let shown = false;
  let active = null;
  try { shown = sessionStorage.getItem(sessionKey) === '1'; } catch (_) {}

  function remember() {
    shown = true;
    try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
  }

  function step(record) {
    return record.root.querySelector('#app-embed')?.getAttribute('data-current-step');
  }

  function expanded(record) {
    return ['form', 'success'].includes(step(record));
  }

  function close(record) {
    const button = record.root.querySelector(closeSelector);
    if (!button) return false;
    button.click();
    return true;
  }

  function reconcile(record) {
    if (!record.host.isConnected || !expanded(record)) {
      record.open = false;
      record.closing = false;
      if (active === record) active = null;
      return;
    }
    if (record.closing) return;
    const excludedOnPhone = phone.matches && record.host.id === 'app-embed-container-525078';
    if (record.open && !excludedOnPhone) return;
    const manual = record.manualUntil > Date.now();
    const otherOpen = active && active !== record && expanded(active);
    if (excludedOnPhone || otherOpen || (!record.open && shown && !manual)) {
      record.manualUntil = 0;
      record.closing = close(record);
      return;
    }
    record.open = true;
    record.manualUntil = 0;
    active = record;
    remember();
  }

  function attach(host) {
    if (records.has(host) || !host.shadowRoot) return;
    const record = {host, root: host.shadowRoot, open: false, closing: false, manualUntil: 0};
    records.set(host, record);
    const style = document.createElement('style');
    style.dataset.ambientFormsGuard = '1';
    style.textContent = `
      #app-embed:not([data-current-step="tease"]) ${closeSelector} {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 44px !important;
        min-width: 44px !important;
        height: 44px !important;
        min-height: 44px !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        touch-action: manipulation;
      }
      [class*="_formContainerCloseButtonPosition_"] {
        top: 14px !important;
        right: 14px !important;
        z-index: 2;
      }
      #app-embed:not([data-current-step="tease"]) ${closeSelector} > svg {
        width: 16px; height: 16px; fill-opacity: 1 !important;
      }
      ${closeSelector}:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
    `;
    if (host.id === 'app-embed-container-517779') {
      // Shopify centers floating forms on phones; preserve the selected corner.
      style.textContent += `
        @media screen and (max-width: 768px) {
          #app-embed[data-layout="floating"][data-position="bottom-left"] [class*="_floating_"] {
            align-items: flex-end !important;
            justify-content: flex-start !important;
            padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
            box-sizing: border-box;
          }
          #app-embed[data-layout="floating"][data-position="bottom-left"] [class*="_formContainer_"] {
            min-width: 0 !important;
            max-width: min(var(--container-max-w, 400px), calc(100% - 4px)) !important;
          }
        }
      `;
    }
    record.root.append(style);
    record.root.addEventListener('click', event => {
      const path = event.composedPath();
      const isClose = path.some(node => node.matches?.(closeSelector));
      if (isClose) {
        remember();
      } else if (path.some(node => node.matches?.('[data-testid="form-teaser"]'))) {
        record.manualUntil = Date.now() + 2000;
      }
    }, true);
    record.root.addEventListener('keydown', event => {
      if (event.key !== ' ') return;
      const button = event.target.closest?.(closeSelector);
      if (!button) return;
      event.preventDefault();
      remember();
      button.click();
    });
    new MutationObserver(() => reconcile(record)).observe(record.root, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['data-current-step']
    });
    reconcile(record);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) attach(node);
    node.querySelectorAll(selector).forEach(attach);
  }

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const record = active && expanded(active) ? active : [...records.values()].find(expanded);
    if (!record) return;
    remember();
    if (close(record)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  phone.addEventListener('change', () => records.forEach(reconcile));
  new MutationObserver(mutations => {
    for (const mutation of mutations) mutation.addedNodes.forEach(scan);
  }).observe(document.body, {childList: true, subtree: true});
  scan(document.body);
  if (window.customElements) {
    customElements.whenDefined('shopify-forms-embed').then(() => scan(document.body));
  }
})();
